module.exports = __webpack_public_path__ + "img/progress_058.8697cd05.png";